import React from 'react';
import './documents.scss';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Button,
  Pager,
  Paging,
  FilterRow,
  Lookup,
  Editing,
  Selection,
  HeaderFilter,
  Item,
  Toolbar,
  SearchPanel,
  Form as GridForm
} from 'devextreme-react/data-grid';

import {Button as ToolbarButton} from 'devextreme-react/button';
import { useState, useEffect, useCallback} from "react";
import { CheckBox } from 'devextreme-react/check-box';

import {Popup as ExtPopup} from 'devextreme-react/popup';
import { Button as PopupButton} from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import TextBox from 'devextreme-react/text-box';
import { SelectBox } from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';

import {
  Validator,
  RequiredRule as ValidatorRequiredRule
} from 'devextreme-react/validator';

import {
  //Item,
  RequiredRule
} from 'devextreme-react/form';

import FileUploader from 'devextreme-react/file-uploader';
import {Logout,SevenDaysFormatted, TodayFormatted} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import pdfIcon from '../../img/pdf.png';
import excelIcon from '../../img/excel.png';
import wordIcon from '../../img/word.png';
import attachIcon from '../../img/attach.png';

const debug = process.env.ENTITY_DEBUG;

export default function ProjectDocuments(props) {

  const projectId = props.projectId;
  const defaultOwner = props.projectId === undefined? 0: props.projectId
  const disableOwner = props.projectId === undefined? false: true
  const { user } = useAuth(); 
  if (!user) 
    Logout();

  const area = "commesse";

  const renderIcon = (cellData) => { 
    let icon = attachIcon;
    const rowData = cellData.data;
    const tipoDoc = rowData?.tipoDocumento;
  
    let label = 'Scarica documento';
  
    if (tipoDoc === '.pdf') {
      icon = pdfIcon;
      label = 'Documento PDF';
    } else if (tipoDoc === '.xlsx' || tipoDoc === '.xls') {
      icon = excelIcon;
      label = 'Documento Excel';
    } else if (tipoDoc === '.docx' || tipoDoc === '.doc') {
      icon = wordIcon;
      label = 'Documento Word';
    }
  
    return (
      <div>
        <img
          src={icon}
          alt={label}
          title={label}
          width="25%"
          height="auto"
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.stopPropagation();
            dowloadFile(cellData);
          }}
        />
      </div>
    );
  };

  const [categorie, setCategorie] = useState({});
  const [commesse, setCommesse] = useState({});
  const [currentRow, setCurrentRow] = useState(1);

  const [isPopupVisible, setPopupVisibility] = useState(false);
  const togglePopup = () => {
    setPopupVisibility(!isPopupVisible);
  };

  const [file, setFile] = useState(null);
  const [descrizione, setDescrizione] = useState("");
  const [ownerId, setOwnerId] = useState(defaultOwner);
  const [categoriaId, setCategoriaId] = useState(0);
  const [dataDoc, setDataDoc] = useState(new Date());
  const [dataScadenza, setDataScadenza] = useState();
  const [fileUploaderValue, setFileUploaderValue] = useState( []);
  const [isStorico, setIsStorico] = useState(false);

  const now = new Date();
  const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Documento'
  const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_DocumentiCommessa'

  const filterPayload = { 
    storico: isStorico,
    commessa: projectId
  };

  const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl2 + '/Find',
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
        var payload = ajaxOptions.data;
        payload.values = JSON.stringify(filterPayload);
        ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
      
  });

  useEffect(() => {
    
    const fetchData = async () => {

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/DocumentoCategoria';
    var newUrl2 =  newServiceUrl2 + "/GetAction";

    const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse';
    var newUrl3 =  newServiceUrl3 + "/GetOpen";
    try {

      const requestOptions = {
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      };
        
      const response2 = await fetch(newUrl2,requestOptions);
      const json2 = await response2.json();
      if (debug === 1)
        console.log(json2);
      setCategorie(json2);

      const response3 = await fetch(newUrl3,requestOptions);
      const json3 = await response3.json();
      if (debug === 1)
        console.log(json3);
      setCommesse(json3);
    } catch (error) {
      console.log("error", error);
    }
  };
    
    fetchData();
  }, []);

  function onRowSelectionChanged({ selectedRowsData }) {

    const data = selectedRowsData[0];
    // if (data !== null) {
    //   setCurrentRow(data.id);
    //   setIsRowSelected(true);
    //   setCurrentDocName(data.nome)
     
    // } else{
    //   setIsRowSelected(false);
    //   setCurrentDocName("")
    // }

  }

  const handleInitNewRow = (e) => {
    e.data.dataDocumento = new Date();
    e.data.createBy = user.name; 
    e.data.areaId = props.area; 
  };

  function closePopup(){
    setPopupVisibility(false);
  };

  const updateActionUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Documento/FileUpload';


  const onCellPreparedGrid = (e) => {
    
    if (e.rowType === "data") {
      if (e.column.dataField === "dataScadenza") 
      { 
        var dataScadenza = e.data.dataScadenza;
        

        if ((dataScadenza !== null))
        {
          if (dataScadenza < TodayFormatted())
          {
            e.cellElement.style.cssText = "color: red; font-weight: bold";
          }
          else if ((dataScadenza < SevenDaysFormatted()) &&  (dataScadenza >= TodayFormatted()) )
          {
            e.cellElement.style.cssText = "color: orange; font-weight: bold";
          }
        }
      
      }
    }

  }

  function dowloadFile(cellData) {

    //const rowData = e.row?.data;
    const rowData = cellData.data;
    const docId = rowData?.id;
    const docName = rowData?.nome;

    if (docId === undefined || !docId ) {
      notify("Seleziona prima un documento valido.", 'warning', 3000);
      return;
    }
    //const url =  serviceUrl + "/FileDownload/" + currentRow;
    const url =  serviceUrl + "/FileDownload/" + docId;

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Errore ${response.status}: ${response.statusText}`);
        }
  
        const contentType = response.headers.get("content-type");
        //console.log("CONTENT " + contentType);
        if (!contentType || !contentType.includes("application/octet-stream")) {
          const err = await response.json();
          throw new Error(err.message);
        }
  
        return response.blob();
      })


      .then(blob => {

        setTimeout(() => {          
        }, 1500);

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        //var slug = currentDocName;

        a.download = docName || "documento";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();  //afterwards we remove the element again 
        
      })

      .catch(error => { notify(error, 'error', 5000); });

  };  

  function onCheckValueChanged(e)  {
    setIsStorico(e.value);
  };

  const showEditButton = useCallback((e) => {
    return true;
  }, []);

  const onDataDocValueChanged = useCallback((e) => {
    setDataDoc(e.value);
  }, []);

  const onDataScadenzaValueChanged = useCallback((e) => {
    setDataScadenza(e.value);
  }, []);

  const handleFileChange = (e) => {
    //setFile(e.value[0]); // DevExpress FileUploader usa `value` come array
    setFile(e.value ? e.value[0] : null); // Aggiorna lo stato del file 
    setFileUploaderValue(e.value); // Aggiorna il valore del FileUploader
  };
  
  const handleUpload = async () => {
    if(ownerId === 0){
      notify("Compilare il campo Commessa.", 'error', 3000);
      return;
    }

    if(categoriaId === 0){
      notify("Compilare il campo Categoria.", 'error', 3000);
      return;
    }

    if (!dataDoc) {
      notify("Compilare la Data Scadenza", 'error', 3000);
      return;
    }

    if (!file) {
      notify("Nessun file selezionato", 'error', 3000);
      return;
    }
  
    const formData = new FormData();
    formData.append("id", currentRow); // ID documento
    formData.append("createBy", user.name);
    formData.append("area", area);
    formData.append("areaId", props.area);
    formData.append("file", file);
    formData.append("descrizione", descrizione);
    formData.append("ownerId", ownerId);
    formData.append("categoriaId", categoriaId);
    formData.append("dataDoc", dataDoc);
    formData.append("dataScadenza", dataScadenza);

    const requestOptions = {
      method: 'POST',
      body: formData,
      headers: {
        //'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };


    try {
      // const response = await fetch(updateActionUrl, {
      //   method: "POST",
      //   body: formData,
      // });
      const response = await fetch(updateActionUrl,requestOptions);
      if (!response.ok) {
        throw new Error("Errore durante il caricamento del file");
      }
  
      const result = await response.json();
      notify(result.message, result.success ? 'success' : 'error',3000);
      setTimeout(() => { 
        if(result.success)
        { 
          closePopup();
          setOwnerId(0);
          setCategoriaId(0);
          setFileUploaderValue([]); // Resetta il valore del FileUploader
          setFile(null);
        }
        else   
        ;     
      }, 3000);
    } catch (error) {
      console.error("Errore:", error);
      notify(error.message, 'Errore', 3000);
    }
  };

  //const getStringId = (row) => `${row.id}`;
  //const getSelectedIds = (selectedRowsData) => (selectedRowsData.length ? selectedRowsData.map(getStringId).join(';') : '');

  // const onSelectionChanged = useCallback(
  //   ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
  //     //setPrefix(null);
  //     setSelectedRowKeys(changedRowKeys);
  //     setSelectedIds(getSelectedIds(selectedRowsData));
  //   }, [],
  // );

  const renderContent = () =>  {
    return (
      <>
        <input type="hidden" name="id" value={currentRow} />
        <input type="hidden" name="area" value={area} />
        <input type="hidden" name="createBy" value={user.name} />

        <div className="dx-field">
          <div className="dx-field-label">Commessa: *</div>
            <div className="dx-field-value">
            <SelectBox
              dataSource={commesse}
              valueExpr="id" 
              displayExpr="nomeEsteso"
              disabled={disableOwner}
              value={ownerId}
              onValueChanged={(e) => setOwnerId(e.value)}
            >
              <Validator>
                <ValidatorRequiredRule message="Campo obbligatorio" />
              </Validator>
            </SelectBox>
          </div>
        </div>

        <div className="dx-field">
          <div className="dx-field-label">Categoria: *</div>
            <div className="dx-field-value">
            <SelectBox
              dataSource={categorie}
              valueExpr="id" 
              displayExpr="nome"
              value={categoriaId}
              onValueChanged={(e) => setCategoriaId(e.value)}
            />
          </div>
        </div>

        <div className="dx-field">
          <div className="dx-field-label">Data Documento: *</div>
          <div className="dx-field-value">
            <DateBox
              defaultValue={now} 
              onValueChanged={onDataDocValueChanged}
              type="date"
            >
              <Validator>
                <ValidatorRequiredRule message="Campo obbligatorio" />
              </Validator>
            </DateBox>
          </div>
        </div>

        <div className="dx-field">
          <div className="dx-field-label">Data Scadenza</div>
          <div className="dx-field-value">
            <DateBox
              //defaultValue={now} 
              onValueChanged={onDataScadenzaValueChanged}
              type="date"
            >

            </DateBox>
          </div>
        </div>
         
        <div className="dx-field">
          <div className="dx-field-label">Descrizione:</div>
          <TextBox
            value={descrizione}
            onValueChanged={(e) => setDescrizione(e.value)}
            className="dx-field-value"
          />
        </div>
        
        <FileUploader
          selectButtonText="Seleziona il file da caricare"
          labelText=""
          accept=".docx, .xlsx, .xls, .pdf"
          uploadMode="useForm"
          value={fileUploaderValue}
          onValueChanged={handleFileChange}
        />

        <PopupButton className="button" text="Carica" type="success" onClick={handleUpload} />
        <PopupButton className="button" text="Chiudi" type="normal" onClick={closePopup} />
      </>         
    )
  }


  return (
  <React.Fragment>
    <h2 className={'content-block'}></h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
          
      <DataGrid
        dataSource={remoteDataSource}
        focusedRowEnabled={true}
        onInitNewRow={handleInitNewRow}
        onSelectionChanged={onRowSelectionChanged}
        onCellPrepared={onCellPreparedGrid}
        dateSerializationFormat= {'yyyy-MM-dd'}
      >
        <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <HeaderFilter visible={true} />
        <Toolbar>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='add'
              hint='Nuovo Documento'
              onClick={togglePopup} 
            />
          </Item>
          <Item location="after">
            <CheckBox  
              value={isStorico} onValueChanged={onCheckValueChanged}
              defaultValue={isStorico}
              text="  Visualizza archiviati   "
            >
            </CheckBox>
          </Item> 
          <Item name="searchPanel" className="offer-toolbar"/>
        </Toolbar>
        <Selection mode="single" />
        <Editing
          mode="form"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        >
          <GridForm>
            <Item dataField="categoriaId" />
            <Item dataField="ownerId" />
            <Item dataField="nome" />
            <Item dataField="path"/>
            <Item dataField="dataDocumento"/>
            <Item dataField="dataScadenza"/>
            <Item dataField="descrizione"/> 
            <Item dataField="avviso"/>
            <Item dataField="archiviato"/>
            <FileUploader selectButtonText="Seleziona il file da caricare" labelText="" accept=".docx, .xlsx, .xls, .pdf" uploadMode="useForm" />
          </GridForm>
        </Editing>
        <Column dataField="id" visible={false}/>
        <Column dataField="areaId" visible={false}/>
       
        <Column dataField="ownerId" caption="Commessa" width={140} allowEditing={false} visible={!disableOwner}>
          <Lookup dataSource={commesse} valueExpr="id" displayExpr="nomeEsteso" />
          <RequiredRule/>
        </Column>
        <Column dataField="nome" caption="Nome Documento" allowEditing={false}/>
        <Column dataField="tipoDocumento" allowEditing={false} visible={false}/>
        <Column dataField="path" caption="Percorso" visible={false} allowEditing={false}/>
        <Column dataField="descrizione" />
        <Column dataField="categoriaId" caption="Categoria" visible={true} allowEditing={false}>
          <Lookup dataSource={categorie} displayExpr="nome" valueExpr="id" />
          <RequiredRule/>
        </Column>
        <Column dataField="dataDocumento" dataType="date" format= {'dd/MM/yyyy'}>
          <RequiredRule/>
        </Column>
        <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'}/>
        <Column dataField="createBy" visible={false}/>
        <Column dataField="avviso" caption="Avviso Scadenza"/>
        <Column dataField="archiviato" visible={true}/>
        <Column dataField="" width={100} allowSorting={false} cellRender={renderIcon} alignment='center'/>
        <Column type="buttons">
          <Button name="edit" visible={showEditButton} />
          <Button name="delete" visible={showEditButton}/>
        </Column>

      </DataGrid>  

        <div>
          <ExtPopup
            width={600}
            height={640} 
            showTitle={true}
            title="Carica documento"
            visible={isPopupVisible}
            hideOnOutsideClick={true}
            onHiding={togglePopup}
            contentRender={renderContent}
          > 
          </ExtPopup> 
        </div>

      </div>
    </div>
  </React.Fragment>
)};
